<template>
  <h2 class="section-title" :class="titleClasses">
    {{ title }}
  </h2>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    titleClasses() {
      const width = this.$windowWidth.value;

      if (width >= 1920) {
        return ['u-typography-helvetica', 'u-text-display', 'u-text-display--l'];
      }

      return ['u-typography-helvetica', 'u-text-display', 'u-text-display--m'];
    }
  }
};
</script>
